export default __webpack_public_path__ + "static/media/fastfood_2.b7012f50.jpg";